import type { MouseEvent } from "react";
import useViewMode from "store/viewMode/viewMode.store";
import { useBackgroundTask } from "store/background-task/background-task.store";
import { removeProductsAttachments } from "api/order";
import { logoutUser } from "tools/auth/logoutCleanup";

type LogoutReason = "manual" | "password-reset";

export const useLogout = () => {
  const { isViewOnly } = useViewMode();
  const backgroundTaskStore = useBackgroundTask();

  return async (
    reasonOrEvent?:
      | LogoutReason
      | MouseEvent<HTMLButtonElement>
      | MouseEvent<HTMLAnchorElement>
  ) => {
    if (isViewOnly) return;

    const reason: LogoutReason =
      typeof reasonOrEvent === "string" ? reasonOrEvent : "manual";

    await logoutUser({
      reason,
      beforeCleanup: async () => {
        try {
          backgroundTaskStore.clear();
        } catch (error) {
          console.warn("Failed to clear background tasks during logout", error);
        }

        try {
          await removeProductsAttachments();
        } catch (error) {
          console.warn(
            "Failed to remove product attachments during logout",
            error
          );
        }
      },
    });
  };
};
